import angular, { IPromise } from "angular";
import { IFieldArray } from "AngularFormly";
import formUtilities from "../../../ui-formly/formUtilities";
import { IResponseStatus } from "../../server/query";

export interface FormSubmitArgs {
  model: unknown;
  formViewController: FormViewController;
}

export class FormViewController {
  static $inject = [];

  form!: angular.IFormController;
  httpPending: boolean = false;

  //bindings
  fields!: IFieldArray;
  model!: unknown;
  title!: string;
  showButtonsAtTop: boolean = false;
  onSubmit!: (args: FormSubmitArgs) => IPromise<void>;
  onCancel!: (args: FormSubmitArgs) => IPromise<void>;

  constructor() {}

  submit() {
    formUtilities.clearServerErrors(this.form);

    if (this.form.$valid) {
      this.httpPending = true;
      this.onSubmit({
        model: this.model,
        formViewController: this,
      }).finally(() => {
        this.httpPending = false;
      });
    }
  }

  cancel() {
    this.onCancel({
      model: this.model,
      formViewController: this,
    });
  }

  static unknownErrror = {
    ErrorCode: "unknown",
    FieldName: "unknown",
    Message: "Unknown Error occurred",
  };

  setApiErrors(responseStatus?: IResponseStatus, validationPrefix?: string) {
    const errors = (
      responseStatus?.Errors ?? [FormViewController.unknownErrror]
    ).map((e) => {
      return {
        ...e,
        FieldName:
          (validationPrefix ? `${validationPrefix}.` : "") + e.FieldName,
      };
    });
    
    formUtilities.setServiceStackServerErrors(errors, this.form);
  }
}
